import { TableRow } from '@mui/material';

import { GDMTableRowComponent } from './GDMTableRow.type';

/* TODO: Implement component using GDM default design */
const GDMTableRow: GDMTableRowComponent = props => <TableRow {...props} />;

export default GDMTableRow;
